import { QueryClient } from '@tanstack/react-query'

import type { SelectFc, QueryOptions } from '@app/types/QueryOptions'

export const fetchQueryOptions = async <OptionType, ResponseResultType>(
  queryClient: QueryClient,
  queryOptions: QueryOptions<OptionType, ResponseResultType>
): Promise<ReturnType<SelectFc<OptionType, ResponseResultType>>> => {
  const { queryKey, queryFn, select } = queryOptions

  const response = await queryClient.fetchQuery({
    queryKey,
    queryFn: async () => await queryFn(),
    staleTime: Infinity
  })

  return select(response)
}
